  let PRIMARY_SERVER_URL = `${window.location.protocol}//${window.location.hostname}/api/`;
  if(PRIMARY_SERVER_URL.includes("localhost")){ 
    PRIMARY_SERVER_URL = process.env.REACT_APP_PRIMARY_SERVER_URL
  }
let activeServerURL = PRIMARY_SERVER_URL


const token = localStorage.getItem("token");

/************************************************************************/


async function connectToClassAPI(tcontextURL, tmethod, data, type) {
  try {
    const storedToken = token ?? localStorage.getItem("token");

    const headers = {
      "Content-Type": "application/json",
    };

    // ✅ Only attach Authorization when token exists
    if (storedToken) {
      headers.Authorization = `Bearer ${storedToken}`;
    }

    const response = await fetch(activeServerURL + tcontextURL, {
      method: tmethod || "GET",
      headers,
      body: data ? JSON.stringify(data) : undefined,
    });

    console.log("STATUS:", response.status);

    if (response.status === 401) {
      localStorage.setItem("SError", "Session Timed out or Unauthorized Access");
      localStorage.removeItem("token");
      localStorage.removeItem("loggedUserInfo");
      window.location.href = type === "user" ? "/booking" : "/login";
      return;
    }

    return response;
  } catch (error) {
    console.error("Error connecting to API:", error);

    // if (activeServerURL === PRIMARY_SERVER_URL) {
    //   activeServerURL = SECONDARY_SERVER_URL;
    //   return connectToClassAPI(tcontextURL, tmethod, data, type);
    // } else {
    //   activeServerURL = PRIMARY_SERVER_URL;
    //   return false;
    // }
  }
}



/************************************************************************/

export async function loginUser(credentials) {
  console.log(credentials);
  const response = await fetch(activeServerURL + "login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  });
  console.log("Checking login API response");

  return response;
}
/**************BusinesInfo View ***************/
export async function getGBussinessInfo(bId) {
  return await connectToClassAPI(`businessinfo/${bId}`)

}
export async function getStaffProfile(sId) {
  return await connectToClassAPI(`staff/profile/${sId}`);
}
export async function deleteStaff(bId) {
  return await connectToClassAPI(`staff/${bId}`, "DELETE");
}
export async function createGBussinessInfo(updates) {
  return await connectToClassAPI(`businessinfo/create`, "PUT", updates);
}
export async function numberSignUp(updates) {
  return await connectToClassAPI(`businessinfo/phonenumber`, "POST", updates);
}

export async function numbermessage(updates) {
  return await connectToClassAPI(`businessinfo/urlnumber`, "POST", updates);
}
export async function sendReceiptMail(bId, emailid, reciptLink, logo) {
  const emailList = emailid.join(',');
  console.log(emailList, "99999999999", bId, emailid, reciptLink, logo);
  // console.log(typeof content);
  const updates = {
    link: reciptLink,
    mail: emailList,
    logo: logo,

  }
  return await connectToClassAPI(`gr/mails/receiptmail/${bId}`, "POST", updates);
}

export async function getWaiverSettingsbyGymid(uid) {
  return await connectToClassAPI(`waiver/Wsetting/gymid/${uid}`);
}

export async function saveStaff(updates, bId) {
  return await connectToClassAPI(`staff/${bId}`, "POST", updates);
}
export async function getGymPlansList(bId) {
  return connectToClassAPI(`plans/${bId}`)
}
export async function getCheckStaff(bId) {
  return await connectToClassAPI(`staff/check/get/${bId}`);
}

export async function getStaffInfo(bId) {
  return await connectToClassAPI(`staff/${bId}`);
}
export async function createClass(bId, updates) {
  return await connectToClassAPI(`class/${bId}`, "POST", updates);
}
// export async function update(updates, bId) {
//   return await connectToAPI(`segment/${bId}`, "PUT", updates);
// }
export async function getClassList(bId, updates) {
  // console.log(updates);
  return await connectToClassAPI(`class/allclasses/${bId}`, 'POST', updates);
}

export async function getClass(bId) {
  return await connectToClassAPI(`class/${bId}`);
}
export async function deleteClass(bId, cid) {
  return await connectToClassAPI(`class/${bId}?classid=${cid}`, "DELETE");
}
export async function createCategory(bId, updates) {
  return await connectToClassAPI(`class/category/${bId}`, "POST", updates);
}
export async function getCategory(bId) {
  return await connectToClassAPI(`class/category/${bId}`);
}
export async function deleteCategory(bId, cid) {
  console.log(bId, cid, 'bId, cid');

  return await connectToClassAPI(`class/category/${bId}?categoryid=${cid}`, "DELETE");
}
export async function reqConfirmPaymentStatus(uid) {
  return await connectToClassAPI(`paymentlink/requestconfirmpaymentstatus/${uid}`);
}
export async function createCancellationPolicy(bId, updates) {
  return await connectToClassAPI(`class/policy/${bId}`, "POST", updates);
}
export async function saveGBussinessInfo(updates, bId) {
  return await connectToClassAPI(`businessinfo/${bId}`, "PUT", updates);
}
export async function getEnvFileData() {
  return await connectToClassAPI("businessinfo/env-file/data")
}
export async function getLocation(bId) {
  return await connectToClassAPI(`geolocation/${bId}`);
}
export async function getPaymentLinkSetting(bId) {
  return await connectToClassAPI(`paymentlink/paymentlinksetting/${bId}`);
}
export async function updateWaiverSettings(updates, bId, type) {
  return await connectToClassAPI(`waiver/Wsetting/${bId}`, "POST", updates, type);
}
export async function getCancellationPolicy(bId) {
  return await connectToClassAPI(`class/policy/${bId}`);
}
export async function deleteCancellationPolicy(bId, pid) {
  return await connectToClassAPI(`class/policy/${bId}?policyid=${pid}`, "DELETE");
}

export async function updateLocation(bId, updates) {
  return await connectToClassAPI(`geolocation/${bId}`, "POST", updates);
}

export async function createTrainer(bId, updates) {
  return await connectToClassAPI(`class/trainer/${bId}`, "POST", updates);
}

export async function getTrainer(bId) {
  return await connectToClassAPI(`class/trainer/${bId}`);
}
export async function deleteTrainer(bId, tid) {
  return await connectToClassAPI(`class/trainer/${bId}?trainerid=${tid}`, "DELETE");
}

export async function CreateSchedule(bId, updates) {
  return await connectToClassAPI(`class/schedule/${bId}`, "POST", updates);
}
export async function getSchedule(bId) {
  return await connectToClassAPI(`class/schedule/${bId}`);
}
export async function deleteSchedule(bId, sid, isapplied) {
  return await connectToClassAPI(`class/schedule/${bId}?scheduleid=${sid}&isapplied=${isapplied}`, "DELETE");
}

export async function verifyNumber(updates) {
  return await connectToClassAPI(`businessinfo/numberverify`, "POST", updates);
}

export async function memberByNumber(bId, updates, type) {
  console.log(updates, "updates");

  return await connectToClassAPI(`members/by-number/${bId}`, "POST", updates, type);
}

export async function classRandomTid() {
  return await connectToClassAPI(`transaction/transcation/randomtid`, "GET");
}
export async function createClassTransaction(bId, update) {
  return await connectToClassAPI(`class/transaction/${bId}`, "PUT", update);
}
export async function getClassTransactions(bId, tdata) {
  return await connectToClassAPI(`class/transaction/${bId}`, "POST", tdata);
}
export async function authorzationOtp(updates) {
  return await connectToClassAPI(`businessinfo/authorazationotp`, "POST", updates);
}

export async function getFailedClassTransactions(bid) {
  return await connectToClassAPI(`class/failedtransaction/${bid}`);
}

export async function getClassTransactionbyTid(tId, bId) {
  return await connectToClassAPI(`class/transactionbyid/${tId}?gymid=${bId}`);
}

export async function getClassTransactionbyNumber(bId, tdata) {

  return await connectToClassAPI(`class/transaction-by-number/${bId}`, "POST", tdata);
}


export async function deleteClassTransactions(bid, tid) {
  // console.log(bid, tid, '3244444444444444444444');

  return await connectToClassAPI(`class/transaction/${bid}?transid=${tid}`, "DELETE");
}

export async function checkMembershipDiscount(bId, update, type) {
  return await connectToClassAPI(`class/checkmembership/${bId}`, "POST", update, type);
}

export async function getBussinessInfobyUrl(url, type) {
  return await connectToClassAPI(`class/businessdetail/${url}?type=${type}`);
}

export async function createMembers(bid, membersdata, type) {
  return await connectToClassAPI(`members/addmembers/${bid}`, "PUT", membersdata, type);
}
export async function getclassDashboardInfo(bId) {
  return await connectToClassAPI(`class/classdashboard/${bId}`);
}
export async function getClassBookingInfo(bId) {
  return await connectToClassAPI(`class/classbooking/${bId}`);
}

export async function uploadClassInvoice(tId, update) {
  return await connectToClassAPI(`class/uploadclassinvoice/${tId}`, "POST", update);
}

export async function getClassInvoicehtmlcontent(tId, gid) {
  return await connectToClassAPI(`class/invoicecontent/${tId}?Gid=${gid}`);
}
export async function createclassRefund(gid, Update) {
  return await connectToClassAPI(`class/refund/${gid}`, "PUT", Update);
}

export async function createRazorpayOrder(Update) {
  return await connectToClassAPI(`razorpay/create-order`, "POST", Update);
}

export async function verifyRazorpayOrder(Update) {
  return await connectToClassAPI(`razorpay/verify-payment`, "POST", Update);
}

export async function checkRazorpayOrderStatus(Update) {
  return await connectToClassAPI(`razorpay/check-order-status`, "POST", Update);
}

export async function downloadclassinvoice(update, type) {
  return await connectToClassAPI(`class/downloadclassinvoice/${update.bid}`, "POST", update, type)
}
export async function createRazorpayGateway(gid, Update) {
  return await connectToClassAPI(`razorpay/updategateway/${gid}`, "PUT", Update);
}

export async function getRazorpayGateway(gid) {
  return await connectToClassAPI(`razorpay/getrazorgateway/${gid}`);
}

export async function createOrderWithKeys(update) {
  return await connectToClassAPI(`razorpay/createorderwithkeys`, "POST", update);
}

export async function verifyOrderWithKeys(update) {
  return await connectToClassAPI(`razorpay/verifyorderwithkeys`, "POST", update);
}

export async function setRazorpayGatewayIsverfied(update) {
  return await connectToClassAPI(`razorpay/gateway-isverfied`, "POST", update);
}

export async function getAdminById(uId) {
  return await connectToClassAPI(`staff/profile/${uId}`);
}
export async function saveAdmin(updates, bId) {
  return await connectToClassAPI(`staff/${bId}`, "PUT", updates);
}

export async function createSubDomain(bid, Update) {
  return await connectToClassAPI(`businessinfo/subdomains/${bid}`, "PUT", Update);
}
export async function getAllSubDomain(domain) {
  return await connectToClassAPI(`businessinfo/subdomains/${domain}`, "GET");
}

//getMembersBySchedule
export async function getMembersBySchedule(id, updates) {
 
  return await connectToClassAPI(`class/getmembersbyschedule/${id}`, "POST", updates);
}



export async function logEvent(data, gymId) {
  return await connectToClassAPI(`logEvent/${gymId}`, "POST", data);
}
export async function getLogEventFilter(data, gymId) {
  return await connectToClassAPI(`logEvent/filter/${gymId}`, "POST", data);
}
export async function getlogEvent(gymId) {
  return await connectToClassAPI(`logEvent/${gymId}`);
}

export async function updateClassBookSettings(id, updates) {
  return await connectToClassAPI(`class/updateclassbooksettings/waiversettings/${id}`, "POST", updates);

}

export async function getClassBookingWaiverSettings(gid) {
  return await connectToClassAPI(`class/getclassbookwaiversettings/${gid}`);
}

export async function createAnnouncement(bid, Update) {
  return await connectToClassAPI(`businessinfo/announcement/${bid}`, "POST", Update);
}

export async function getAnnouncements(gymid) {
  return await connectToClassAPI(`businessinfo/announcement/${gymid}`, "GET");
}


export async function verifyFailedClassTransaction(updates) {
  return await connectToClassAPI(`class/faildtranscations/convert`, "POST", updates)
}
